import classNames from 'classnames';
import { reverse, times } from 'lodash-es';
import * as React from 'react';
import { v4 } from 'uuid';

import StarRating from '../../../../atoms/icons/StarRating';

import css from './ReviewSummary.module.scss';

interface Props {
  className?: string;
  rate: number;
  rate_count: number;
  rate_count_starby?: {
    one: number;
    two: number;
    three: number;
    four: number;
    five: number;
  };
}

const ReviewSummary = ({
  className,
  rate,
  rate_count,
  rate_count_starby,
}: Props) => {
  if (!rate_count_starby) {
    // tslint:disable-next-line: no-null-keyword
    return null;
  }

  const classes = classNames(css.ReviewSummary, className);
  const rateCaptionClasses = classNames(
    css.ReviewSummary__RateCaption,
    !rate ? css.hasNoRate : '',
  );

  const getCount = (index?: number) => {
    switch (index) {
      case 1:
        return rate_count_starby.one;
      case 2:
        return rate_count_starby.two;
      case 3:
        return rate_count_starby.three;
      case 4:
        return rate_count_starby.four;
      case 5:
        return rate_count_starby.five;
      default:
        return 0;
    }
  };
  const starCounts = [1, 2, 3, 4, 5].map((index) =>
    rate_count < 1 ? 0 : (getCount(index) / rate_count) * 100,
  );
  const graphStyles = (percent: number) => ({
    backgroundColor: percent === 0 ? '#dde1e6' : undefined,
    width: percent === 0 ? '2%' : `${percent}%`,
  });

  return (
    <div className={classes}>
      <figure className={css.ReviewSummary__Rate}>
        <figcaption className={rateCaptionClasses}>
          {rate.toFixed(1) || '-'}
        </figcaption>
        <StarRating
          className={css.ReviewSummary__StarRating}
          rate={Math.floor(rate)}
        />
      </figure>
      <figure className={css.ReviewSummary__Distribution}>
        <table className={css.ReviewSummary__Table}>
          <tbody>
            {rate_count_starby &&
              reverse(times(5)).map((i) => (
                <tr key={v4()}>
                  <th>{i + 1}</th>
                  <td>
                    <div
                      className={css.ReviewSummary__Graph}
                      style={graphStyles(starCounts[i])}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </figure>
    </div>
  );
};

export default ReviewSummary;
